<template>
  <app-content>
    <b-container fluid>
      <b-row>
        <physical-chemical-report
          :asset-module-id="assetModuleId"
          :sample-ids="sampleIds"
        />
      </b-row>
      <b-row
        class="px-3"
        align-h="end"
      >
        <b-button
          class="mt-3 no-internal-print"
          @click="close"
          variant="primary">
          {{ $t('actions.close') }}
        </b-button>
      </b-row>
    </b-container>
  </app-content>
</template>

<script>
import PhysicalChemicalReport
  from '@/domain/components/installation/engineering/physicalChemical/reports/index';

export default {
  name: 'LotsAndParameters',
  components: {
    PhysicalChemicalReport,
  },
  computed: {
    assetModuleId() {
      return this.$route.params.assetModuleId;
    },
    sampleIds() {
      const sampleIdsQuery = this.$route.query.sampleIds;
      if (typeof sampleIdsQuery === 'string') {
        return [sampleIdsQuery];
      }

      return sampleIdsQuery;
    },
  },
  methods: {
    close() {
      this.$confirmMessage({ code: 'MC035' }).accepted(() => {
        window.close();
      });
    },
  },
};
</script>
